import React from 'react';

import GlobalErrorMessage from '../GlobalErrorMessage';

export default function ErrorMessage({errorCode}) {
    return (
        <div className='container'>
            <div className='text-alert maxis-semiBold py-2'>
                <GlobalErrorMessage errorCode={errorCode} />
            </div>
        </div>
    );
}
